import React, { useRef, useState } from "react";
import { Form } from "react-bootstrap";
import FLInput from "../libs/uikit/flinput";
import FLSelect from "../libs/uikit/flselect";
import FLDate from "../libs/uikit/fldate";
import CaptchaInput from "../libs/captcha";
import { MetroSpinner } from "react-spinners-kit";
import moment from "moment";
import Language from "../../services/Language.js";

const l = new Language();

const AdvancedSearch = (props) => {
  const { url, dataDefine } = props;
  const [validated, setValidated] = useState(false);
  const captchaRef = useRef(null);

  const [typeInsurance, setTypeInsurance] = useState("NHA_TU_NHAN");
  const [infoKYC, setInfoKYC] = useState("");
  const [fullname, setFullname] = useState("");
  const [dob, setDob] = useState(null);
  const [licensePlate, setLicensePlate] = useState("");
  const [phoneEmail, setPhoneEmail] = useState("");
  const [typeIsrFlight, setTypeIsrFlight] = useState("");
  const [lastName, setLastName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [returnDate, setReturnDate] = useState(null);
  const [maDC, setMaDC] = useState("");

  const handleTypeInsurance = (typeIsr) => {
    if(typeIsr === 'FLY') {
      setTypeInsurance(typeIsr);
      setTypeIsrFlight("BAY_AT");
      return;
    }
    setTypeInsurance(typeIsr);
  }

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    if (form.checkValidity() === false) {
      return setValidated(true);
    }
    let data;
    switch(typeInsurance){
      case 'NHA_TU_NHAN': {
        data = {
          a2: infoKYC.trim(),
          a3: typeInsurance,
          a4: fullname.trim(),
        }
        break;
      }
      case 'CON_NGUOI': {
        data = {
          a2: infoKYC.trim(),
          a3: typeInsurance,
          a4: fullname.trim(),
          a5: dob,
          // ngày sinh
        }
        break;
      }
      case 'XE_COGIOI': {
        data = {
          a2: phoneEmail.trim(),
          a3: typeInsurance,
          a4: fullname.trim(),
          a7: licensePlate.trim(), // khung, biển số xe
        }
        break;
      }
      case 'FLY': {
        if(typeIsrFlight === "BAY_AT") {
          data = {
            a3: typeIsrFlight,
            a4: `${lastName.trim()} ${firstName.trim()}`,
            a5: fromDate,
            a7: maDC.trim(),
          }
          break;
        }
        if(typeIsrFlight === "DELAY") {
          data = {
            a2: phoneEmail.trim(),
            a3: typeIsrFlight,
            a4: `${lastName.trim()} ${firstName.trim()}`,
            a7: maDC.trim(),
          }
          break;
        }
        if(typeIsrFlight === "LOST_BAGGAGE") {
          data = {
            a2: phoneEmail.trim(),
            a3: typeIsrFlight,
            a4: `${lastName.trim()} ${firstName.trim()}`,
            a7: maDC.trim(),
          }
          break;
        }
        if(typeIsrFlight === "TRAVEL") {
          data = {
            a2: infoKYC.trim(),
            a3: typeIsrFlight,
            a4: fullname.trim(),
            a5: fromDate,
            a6: returnDate,
          }
          break;
        }
        break;
      }
    }
    if (!captchaRef.current.validate()) {
      return;
    }
    props.search(data);
    captchaRef.current.reset();
  };

  const maximumDate = () => {
    const now = moment();
    return {
      year: now.year(),
      month: now.month() + 1,
      day: now.date(),
    };
  };

  return (
    <div>
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-6 mt-3">
            <FLSelect
              disable={false}
              label={l.g("certificate.select_insurance_label", "Select insurance type")}
              value={typeInsurance}
              changeEvent={handleTypeInsurance}
              dropdown={true}
              required={true}
              data={dataDefine.dataType}
            />
          </div>

          {["NHA_TU_NHAN", "CON_NGUOI"].includes(typeInsurance) ? (
            <div className="col-6 mt-3">
              <FLInput
                label={l.g("certificate.identity_label", "ID/ Passport/ Phone")}
                required={true}
                value={infoKYC}
                changeEvent={setInfoKYC}
              />
            </div>
          ) : null}

          {["NHA_TU_NHAN"].includes(typeInsurance) ? (
            <div className="col-12 mt-3">
              <FLInput
                label={l.g("certificate.customer_name_label", "Customer full name")}
                required={true}
                value={fullname}
                changeEvent={setFullname}
              />
            </div>
          ) : null}

          {typeInsurance === "CON_NGUOI" ? (
            <>
              <div className="col-6 mt-3">
                <FLInput
                  label={l.g("certificate.customer_name_label", "Customer full name")}
                  required={true}
                  value={fullname}
                  changeEvent={setFullname}
                />
              </div>
              <div className="col-6 mt-3">
                <FLDate
                  disable={false}
                  value={dob}
                  changeEvent={setDob}
                  label={l.g("certificate.dob_label", "Date of birth")}
                  required={true}
                  maximumDate={maximumDate()}
                />
              </div>
            </>
          ) : null}

          {typeInsurance === "XE_COGIOI" ? (
            <>
              <div className="col-6 mt-3">
                <FLInput
                  label={l.g("certificate.license_plate_label", "Plate/ frame/ engine number")}
                  required={true}
                  value={licensePlate}
                  changeEvent={setLicensePlate}
                />
              </div>
              <div className="col-6 mt-3">
                <FLInput
                  label={l.g("certificate.owner_name_label", "Vehicle owner name")}
                  required={true}
                  value={fullname}
                  changeEvent={setFullname}
                />
              </div>
              <div className="col-6 mt-3">
                <FLInput
                  label={l.g("certificate.phone_email_label", "Phone/ Email")}
                  required={true}
                  value={phoneEmail}
                  changeEvent={setPhoneEmail}
                />
              </div>
            </>
          ) : null}

          {typeInsurance === "FLY" ? (
            <>
              <div className="col-6 mt-3">
                <FLSelect
                  disable={false}
                  label={l.g("certificate.insurance_label", "Insurance")}
                  value={typeIsrFlight}
                  changeEvent={setTypeIsrFlight}
                  dropdown={true}
                  required={true}
                  data={dataDefine.dataTypeIsr}
                />
              </div>
              {["BAY_AT", "DELAY", "LOST_BAGGAGE"].includes(typeIsrFlight) ? (
                <>
                  <div className="col-12 mt-3">
                    <div className="group-ipnv">
                      <FLInput
                        disable={false}
                        value={lastName}
                        changeEvent={(v) => setLastName(v)}
                        label={l.g("certificate.last_name_label", "Last name")}
                        hideborder={true}
                        required={true}
                      />
                      <div className="ver-line"></div>
                      <div className="kkjs">
                        <FLInput
                          disable={false}
                          value={firstName}
                          changeEvent={(v) => setFirstName(v)}
                          hideborder={true}
                          label={l.g("certificate.first_name_label", "First name")}
                          required={true}
                        />
                      </div>
                    </div>
                  </div>
                  {typeIsrFlight === "DELAY" ? (
                    <div className="col-6 mt-3">
                      <FLInput
                        disable={false}
                        value={phoneEmail}
                        changeEvent={setPhoneEmail}
                        label={l.g("certificate.phone_email_label", "Phone/ Email")}
                        required={true}
                      />
                    </div>
                  ) : null}
                   {typeIsrFlight === "LOST_BAGGAGE" ? (
                    <div className="col-6 mt-3">
                      <FLInput
                        disable={false}
                        value={phoneEmail}
                        changeEvent={setPhoneEmail}
                        label={l.g("certificate.phone_email_label", "Phone/ Email")}
                        required={true}
                      />
                    </div>
                  ) : null}
                  {typeIsrFlight === "BAY_AT" ? (
                    <div className="col-6 mt-3">
                      <FLDate
                        disable={false}
                        value={fromDate}
                        changeEvent={setFromDate}
                        label={l.g("certificate.travel_date_label", "Departure date")}
                        required={true}
                      />
                    </div>
                  ) : null}
                  {["BAY_AT", "DELAY", "LOST_BAGGAGE"].includes(typeIsrFlight) ? (
                    <div className="col-6 mt-3">
                      <FLInput
                        disable={false}
                        value={maDC}
                        changeEvent={setMaDC}
                        label={l.g("certificate.booking_code_label", "Booking code")}
                        required={true}
                      />
                    </div>
                  ) : null}
                </>
              ) : (
                <>
                  <div className="col-6 mt-3">
                    <FLInput
                      label={l.g("certificate.customer_name_label", "Customer full name")}
                      required={true}
                      value={fullname}
                      changeEvent={setFullname}
                    />
                  </div>
                  <div className="col-6 mt-3">
                    <FLInput
                      label={l.g("certificate.identity_label", "ID/ Passport/ Phone")}
                      required={true}
                      value={infoKYC}
                      setInfoKYC={setInfoKYC}
                    />
                  </div>
                  <div className="col-12 mt-3">
                    <div className="group-ipnv ">
                      <FLDate
                        disable={false}
                        changeEvent={setFromDate}
                        value={fromDate}
                        label={l.g("certificate.travel_date_label", "Departure date")}
                        required={true}
                        hideborder={true}
                      />
                      <div className="ver-line"></div>
                      <div className="kkjs">
                        <FLDate
                          disable={false}
                          changeEvent={setReturnDate}
                          value={returnDate}
                          label={l.g("certificate.return_date_label", "Return date")}
                          required={true}
                          hideborder={true}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
            </>
          ) : null}

          <div className="col-12 mt-3">
            <CaptchaInput ref={captchaRef} wideLayout={true} />
          </div>

          {/* Nút tìm kiếm và kính lúp xếp chồng, cùng độ rộng với textbox */}
          <div className="col-12 mt-3">
            <div className="row align-items-center">
              {!props.certificate && (
                <div className="col-12 search-guide">
                  <img
                    src={props.isnotfound ? "/img/sdk/notfound.svg" : "/img/sdk/search-icon-big.svg"}
                    alt=""
                    style={{ width: 40, height: 40, objectFit: "contain", opacity: 0.75 }}
                  />
                  <p style={{ fontSize: 11, color: props.isnotfound ? "#dc3545" : "#999", margin: 0 }}>
                    {props.isnotfound
                      ? l.g("certificate.not_found_message", "Certificate not found. Please try again with advanced search")
                      : l.g("certificate.search_guide_message", "Please search for the certificate by entering it in the search bar to view the certificate")}
                  </p>
                </div>
              )}
              <div className="col-12 mt-3">
                <button className="btn-search-kt" disabled={props.loading}>
                  {props.loading ? (
                    <MetroSpinner size={28} loading={props.loading} />
                  ) : (
                    <>
                      <span className="icon-search-kt">
                        <i className="fas fa-search"></i>
                      </span>
                      {l.g("certificate.search_button", "Search")}
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </div>
  );
};
export default AdvancedSearch;
